import { USER_QUERY } from 'queries/user/user.query';
import { FetchUserQuery } from 'queries/user/user.query.generated';
import { getApolloClient } from 'shared/graphql/client';

export const getUser = async () => {
    const {
        data: { user },
        errors
    } = await getApolloClient().query<FetchUserQuery>({
        query: USER_QUERY,
        fetchPolicy: 'network-only'
    });

    if (process.env.NODE_ENV !== 'production' && errors) {
        console.error(errors);
    }

    return user;
};
